const mutations = {
  setLogin(state, isLogin) {
    state.isLogin = isLogin;
  },
  setTEFn(state, TEFn) {
    state.TEFn = TEFn;
  },
  setIM(state, IM) {
    state.IM = IM;
  },
  setMembersFn(state, membersFn) {
    state.membersFn = membersFn;
  },
  setIMFn(state, IMFn) {
    state.IMFn = IMFn;
  },
  setTabDataFn(state, tabDataFn) {
    state.tabDataFn = tabDataFn;
  },
  setVideoUserList(state, videoUserList) {
    state.videoUserList = videoUserList;
  },
  updateVideoUserList(state, { type, index, userInfo }) {
    if (type == 'add') {
      state.videoUserList.unshift(userInfo);
    }
    if (type == 'delete') {
      state.videoUserList.splice(index, 1);
    }
    if (type == 'update') {
      state.videoUserList[index] = userInfo;
    }
  },
  setQuesList(state, questionnaireList) {
    state.questionnaireList = questionnaireList;
  },
  updateQuesList(state, { type, index, queInfo }) {
    if (type == 'add') {
      state.questionnaireList.push(queInfo);
    }
    if (type == 'delete') {
      state.questionnaireList.splice(index, 1);
    }
    if (type == 'update') {
      state.questionnaireList.splice(index, 1,queInfo);
    }
  },
  setInformationList(state, informationList) {
    state.informationList = informationList;
  },
  updateInformationList(state, { type, index, informationInfo }) {
    if (type == 'add') {
      state.informationList.push(informationInfo);
    }
    if (type == 'delete') {
      state.informationList.splice(index, 1);
    }
    if (type == 'update') {
      state.informationList.splice(index, 1,informationInfo);
    }
  },
  setTabQuesFn(state, tabQuesFn) {
    state.tabQuesFn = tabQuesFn;
  },


  setMeetingLayoutConfigList(state, meetingLayoutConfigList) {
    state.meetingLayoutConfigList = meetingLayoutConfigList;
  },
  setMeetingSenceConfigList(state, meetingSenceConfigList) {
    state.meetingSenceConfigList = meetingSenceConfigList;
  },
  setLocaLayoutConfig(state, locaLayoutConfig) {
    state.locaLayoutConfig = locaLayoutConfig;
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  updateUserInfo(state, { name, value }) {
    state.userInfo[name] = value;
  },
  setRoomInfo(state, roomInfo) {
    state.roomInfo = roomInfo;
  },
  updateRoomInfo(state, { name, value }) {
    state.roomInfo[name] = value;
  },
  setTRTCFn(state, TRTCFn) {
    state.TRTCFn = TRTCFn;
  },
  setIMStatus(state, IMStatus) {
    state.IMStatus = IMStatus;
  },
  setIMStatus_initialization(state, info) {
    Object.assign(state.IMStatus[0], info);
  },
  setIMStatus_ready(state, info) {
    Object.assign(state.IMStatus[1], info);
  },
  setIMStatus_login(state, info) {
    Object.assign(state.IMStatus[2], info);
  },
  setIMStatus_join(state, info) {
    Object.assign(state.IMStatus[3], info);
  },


  setTRTCStatus(state, TRTCStatus) {
    state.TRTCStatus = TRTCStatus;
  },
  setTRTCStatus_initialization(state, info) {
    Object.assign(state.TRTCStatus[0], info);
  },
  setTRTCStatus_join(state, info) {
    Object.assign(state.TRTCStatus[1], info);
  },
  setTRTCStatus_loadRemote(state, info) {
    Object.assign(state.TRTCStatus[2], info);
  },
  setTRTCStatus_create(state, info) {
    Object.assign(state.TRTCStatus[3], info);
  },
  setTRTCStatus_push(state, info) {
    Object.assign(state.TRTCStatus[4], info);
  },
  setIsShareScreen(state, isShareScreen) {
    state.isShareScreen = isShareScreen;
  },

  setMeetingConfig(state, meetingConfig) {
    state.meetingConfig = meetingConfig;
  },
  setMeetingInfo(state, meetingInfo) {
    state.meetingInfo = meetingInfo;
  },
  setConferee(state, conferee) {
    state.conferee = conferee;
  },
  setConfereeCurrentStatus(state, confereeCurrentStatus) {
    state.confereeCurrentStatus = confereeCurrentStatus;
  },
  setMeetingCurrentStatus(state, meetingCurrentStatus) {
    state.meetingCurrentStatus = meetingCurrentStatus;
  },
  setSdkAppId(state, sdkAppId) {
    state.sdkAppId = sdkAppId;
  },
  setMcuMixTranscode(state,url) {
    state.mcuMixTranscodeUrl = url;
  },
  setTipsFlag(state,tipsFlag) {
    state.tipsFlag = tipsFlag;
  },
  changeTipSurveyInfoList(state,{type, surveyCode}) {
    if (type == 'add') {
      let surveyCodeIndex = state.surveyCodeList.indexOf(surveyCode)
      if(surveyCodeIndex!=-1){
        state.surveyCodeList.splice(surveyCodeIndex,1)
        state.surveyCodeList.push(surveyCode)
      } else {
        state.surveyCodeList.push(surveyCode)
      }
    }else if(type == 'delete'){
      let surveyCodeIndex = state.surveyCodeList.indexOf(surveyCode)
      state.surveyCodeList.splice(surveyCodeIndex,1)
    }
  },
  setScreenShareStream(state, screenShareStream) {
    state.screenShareStream = screenShareStream;
  },
  updateAllowGenerator(state, allowGenerator) {
    state.allowGenerator = allowGenerator;
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js